import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import { useNavigate } from 'react-router-dom';
import ProgressBar from 'react-bootstrap/ProgressBar';

import "./academicCourseCard.css";
import { ROUTES } from '../../../constant';
import PrimaryButton from '../primaryButton/primaryButton';


const AcademicCourseCard = (props) => {
    const navigate = useNavigate();
    let strLowerCase = props.level.toLowerCase();
    let wordArr = strLowerCase.split(" ").map(function(currentValue) {
        return currentValue[0].toUpperCase() + currentValue.substring(1);
    });

    const level = wordArr.join(" ");

    const handleViewButton = (slug_name) => { 
        navigate(ROUTES.ACADEMIC_COURSE_DETAIL + "/" + slug_name);
    }

    return (
        <Col>
            <Card>
                <Card.Body>
                    <Row>
                        <Col xs={4} md={4}>
                            <Card.Img variant="top" src={props.image} className="course-card-img" />
                        </Col>
                        <Col xs={8} md={8}>
                            <Card.Title className='course-card-title'>{props.name}</Card.Title>
                            <Card.Text >
                                <label className='course-card-level'>Level: {level}</label><br/>
                                <label className='course-card-lesson-count'>{props.lesson_count} Lessons </label>
                            </Card.Text>
                            <PrimaryButton
                                text="View"
                                onClick={() => handleViewButton(props.slug_name)}
                                customStyle={{backgroundColor: "#fbb615"}}
                            />
                        </Col>
                    </Row>
                    <Row className='course-card-progressbar-row'>
                        <Col xs={10}>
                            <ProgressBar className='course-card-progressbar' now={props.progress} />
                        </Col>
                        <Col xs={2}>
                            <label>{props.progress}%</label>
                        </Col>
                    </Row>
                    
                </Card.Body>
            </Card>
        </Col>
    );
}

export default AcademicCourseCard;
